import * as React from 'react'
import styled from '../../theme/styled'
import { connect } from 'react-redux'

import { Store } from '../../reducers/index'
import {
  getNumCategories,
  getTouchedCategories,
  getValidCategories
} from '../../reducers/project'

const ProgressWrapper = styled.div`
  color: ${({ theme }) => theme.infoBar.color};
  font-weight: 600;
  padding: 15px 20px;
  width: calc(100% - 320px);
  background: ${({ theme }) => theme.infoBar.background};
`

type PrevisProgressProps = {
  numCategories: number
  touchedCategories: string[]
  validCategories: string[]
}

const messages = [
  'Progress',
  'Progress',
  'Almost ready',
  'One more to go',
  'Everything set, press "calculate" to see the results.'
]

const badInputsMsg = 'One or more parameters invalid.'

const PrevisProgress: React.SFC<PrevisProgressProps> = (
  props: PrevisProgressProps
) => {
  const progress = props.touchedCategories.length
  const total = props.numCategories

  let msg =
    progress < messages.length
      ? messages[progress - 1]
      : messages[messages.length - 1]

  const invalid = props.numCategories - props.validCategories.length

  if (invalid > 0) {
    msg = badInputsMsg
  }

  return (
    <ProgressWrapper>
      Step {progress}/{total}: {msg}
    </ProgressWrapper>
  )
}

const mapStateToProps = (state: Store.Complete) => ({
  numCategories: getNumCategories(state),
  touchedCategories: getTouchedCategories(state),
  validCategories: getValidCategories(state)
})

export default connect(mapStateToProps)(PrevisProgress)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Progress.tsx